import * as TargetedContentClient from 'ContentData/api/TargetedContent';
import { createGenericFetchAction } from 'ContentData/helpers/reduxHelpers';
import { TARGETED_FETCH_CRITERION } from 'ContentData/actions/ActionTypes';
const fetchTargetedCriterionAction = createGenericFetchAction(TARGETED_FETCH_CRITERION, TargetedContentClient.fetchSmartCriterion);
export const fetchSmartContent = data => {
  return fetchTargetedCriterionAction(data);
};